<mat-tab-group mat-stretch-tabs="false">
  <mat-tab [label]="'Supervisors' | translate">
    <ng-template matTabContent>
      <app-worker-supervisors-list [workerId]="workerId" [isLoggedUserProfile]="isLoggedUserProfile$ | async"></app-worker-supervisors-list>
    </ng-template>
  </mat-tab>
  <mat-tab [label]="'Subordinates' | translate">
    <ng-template matTabContent>
      <app-worker-subordinates-list [workerId]="workerId"></app-worker-subordinates-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
